module.exports = __webpack_public_path__ + "static/media/Admin Dashboard Round.bf71394c.png";